import React from 'react';

export default function PromoWebsitePage() {
  return (
    <iframe
      title="Digital Ninja"
      src="/digital_ninja_v3_1_live.html?v=20261017-perf"
      style={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100%',
        border: 0,
        background: '#020504',
      }}
    />
  );
}
